const useIsDevUrl = () => {
    const url = window.location.href;
    return url.includes('curve-demo');
}

export default useIsDevUrl;
